<div class="feedback-listing-container">
  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Loading feedback assignments...</p>
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading">
    <!-- Header Section -->
    <div class="header-section">
      <h1 class="dashboard-title">Employee Feedback Dashboard</h1>
    </div>

    <!-- Statistics Section -->
    <div class="statistics-section" *ngIf="statistics">
      <div class="stat-card">
        <div class="stat-value">{{ statistics.total_assigned }}</div>
        <div class="stat-label">Total Assigned</div>
      </div>
      <div class="stat-card pending">
        <div class="stat-value">{{ statistics.total_pending }}</div>
        <div class="stat-label">Pending</div>
      </div>
      <div class="stat-card completed">
        <div class="stat-value">{{ statistics.total_completed }}</div>
        <div class="stat-label">Completed</div>
      </div>
    </div>

    <!-- Content Section -->
    <div class="content-section">
      <div class="page-header">
        <h2 class="page-title">Feedback Assignments</h2>
      </div>

      <!-- Filter Section -->
      <div class="filter-section">
        <div class="search-box">
          <input 
            type="text" 
            [(ngModel)]="searchText"
            (input)="onSearch()"
            placeholder="Search by survey, customer name..."
            class="search-input"
          />
          <button class="search-btn" (click)="onSearch()">
            <i class="search-icon">🔍</i>
          </button>
        </div>

        <div class="filter-box">
          <label class="filter-label">Status:</label>
          <select 
            [(ngModel)]="selectedStatus"
            (change)="onStatusChange()"
            class="filter-select"
          >
            <option *ngFor="let status of statusOptions" [value]="status">
              {{ status }}
            </option>
          </select>
        </div>

        <button class="btn-clear" (click)="clearFilters()" *ngIf="searchText || selectedStatus !== 'ALL'">
          ✖ Clear Filters
        </button>
      </div>

      <!-- Results Count -->
      <div class="results-info">
        <p>Showing <strong>{{ filteredAssignments.length }}</strong> of <strong>{{ allAssignments.length }}</strong> assignments</p>
      </div>

      <!-- Table Container -->
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>Survey Number</th>
              <th>Survey Title</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Questions</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          
          <tbody>
            <tr *ngFor="let assignment of filteredAssignments">
              <td>{{ assignment.survey_number }}</td>
              <td>
                <div class="survey-info">
                  <div class="survey-title">{{ assignment.survey_title }}</div>
                  <div class="survey-description">{{ assignment.survey_description }}</div>
                </div>
              </td>
              <td>{{ assignment.customer_name }}</td>
              <td>
                <div class="date-info">
                  <div class="date-label">{{ getDateLabel(assignment) }}</div>
                  <div class="date-value">{{ getDisplayDate(assignment) }}</div>
                </div>
              </td>
              <td class="text-center">{{ getTotalQuestions(assignment) }}</td>
              <td>
                <span class="status-badge" [ngClass]="getStatusClass(assignment.survey_status)">
                  {{ assignment.survey_status }}
                </span>
              </td>
              <td (click)="$event.stopPropagation()">
                <div class="action-buttons">
                  <button 
                    class="btn-action btn-provide" 
                    (click)="onProvideFeedback(assignment)"
                    title="Provide Feedback"
                    *ngIf="assignment.survey_status === 'Pending'"
                  >
                    ✍️ Provide
                  </button>
                  <button 
                    class="btn-action btn-view" 
                    (click)="onViewDetails(assignment)"
                    title="View Details"
                  >
                    📄 View
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="filteredAssignments.length === 0">
              <td colspan="7" class="no-data">
                <div class="no-data-message">
                  <span class="no-data-icon">📋</span>
                  <p>No feedback assignments found</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>